"use client"
import { useGSAP } from "@gsap/react"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { useRef } from "react"
import { useApp } from "@/context/AppContext";

export default function BlurredDecorationItem({ src, width, height, widthInRem, left, top, weight = 1 }) {
  const { ready, getTransitionReady } = useApp()
  const root = useRef(null)
  const img = useRef(null)
  const scrollTriggerRef = useRef(null)

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add(
      {
        hasMotion: "(prefers-reduced-motion: no-preference)",
        hasNoMotion: "(prefers-reduced-motion: reduce)",
      },
      async (context) => {
        const { hasMotion, hasNoMotion } = context.conditions;

        if (hasMotion) {
          await ready;
          await getTransitionReady();
          scrollTriggerRef.current?.kill();
          scrollTriggerRef.current = ScrollTrigger.create({
            trigger: root.current,
            start: 'top bottom+=50%',
            end: 'bottom top-=50%',
            scrub: true,
            onEnter: () => {
              gsap.to(root.current, {
                opacity: 0.2
              })
            },
            onUpdate: (self) => {
              const progress = self.progress
              const parallaxValue = (progress - 0.5) * 2 * 100 * weight
              gsap.to(img.current, {
                yPercent: parallaxValue
              })
            }
          })
        } else if (hasNoMotion) {
          gsap.set(root.current, {
            opacity: 0.2
          })
        }
      }
    )

    return () => {
      scrollTriggerRef.current?.kill();
      mm.revert();
    }
  }, [weight])

  return (
    <div
      ref={root}
      className="absolute opacity-0 blur-[5px]"
      style={{
        left: `${Math.round(left * 100) / 100}%`,
        top: `${Math.round(top * 100) / 100}%`,
        width: `${Math.round(widthInRem * 100) / 100}rem`,
      }}
    >
      <img
        ref={img}
        src={src}
        alt=""
        width={width}
        height={height}
        className="w-full h-auto will-change-transform"
      />
    </div>
  )
}
